














import { Vue, Component, Mixins } from "vue-property-decorator";
import VIcon from "@/components/VIcon.vue";
import MultiLevelDropdown from "@/components/MultiLevelDropdown.vue";
import { Getter, Mutation } from "vuex-class";
import { User } from "@/models";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import { MutationMethod } from "vuex";
import AgentsUserInfoMixin from "@/mixins/http/Agents/UserInfoMixin";
import ClientUserInfo from "@/models/Agents/UserInfo";

@Component({
  components: { MultiLevelDropdown, VIcon },
})
export default class ProfileSelect extends Mixins(AgentsUserInfoMixin) {
  @Getter("user") user!: User;
  @Getter("profile") profile!: AdcontrolProfile;

  @Mutation("setProfile") setProfile!: MutationMethod;
  @Mutation("setAgentUserInfos") setAgentUserInfos!: MutationMethod;

  open = false;

  toggle() {
    this.open = !this.open;
  }

  closeDropdown() {
    if (this.open) {
      this.open = false;
    }
  }

  mounted() {
    if (
      !this.user.adcontrolProfiles ||
      this.user.adcontrolProfiles.length === 0
    ) {
      return;
    }

    if (!this.profile && !this.user.isAdmin) {
      this.setProfile(this.user.adcontrolProfiles[0]);
    }

    this.assignAgentUserInfosByProfile(
      this.profile ? this.profile.slug : this.user.adcontrolProfiles[0].slug
    );
  }

  onSelected(option: MultiLevelObject) {
    this.setProfile(
      this.user.adcontrolProfiles?.find((p) => p.slug == option.id)
    );

    this.assignAgentUserInfosByProfile(option.id);

    this.closeDropdown();
  }

  async assignAgentUserInfosByProfile(profile?: string) {
    if (!profile) {
      this.setAgentUserInfos(undefined);
      return;
    }

    try {
      this.setAgentUserInfos(await this.currentAgentUserInfos(profile));
    } catch {
      this.setAgentUserInfos(undefined);
    }
  }

  get items(): MultiLevelObject[] {
    return (
      this.user.adcontrolProfiles
        ?.map((p: AdcontrolProfile) => {
          return {
            id: p.slug,
            text: p.name,
            selected: p.slug == this.profile?.slug,
          };
        })
        ?.sort((a, b) => a.text.localeCompare(b.text)) ?? []
    );
  }

  get profileCount(): number {
    return this.user.adcontrolProfiles?.length ?? 0;
  }
}
